const employerView = (data) => {
    let formData = data && data.getEmployerById && data.getEmployerById.EmployerFormData
    if(formData){  
        let view = {
            name: formData.new_profile_emp_profile_name,
            sections: [
                {
                    name: 'Employer Name(s)',
                    fields: [
                        {
                            number: 1,
                            label: 'Legal Business Name',
                            value: formData.new_profile_emp_legal_name,

                        },
                        {
                            number: 2,
                            label: 'Trade Name / Doing Business As (DBA), if applicable',
                            value: formData.new_profile_emp_dba,
                        },
                    ]
                },
                {
                    name: 'Address',
                    fields: [
                        {
                            number: 3,
                            label: 'Address 1',
                            value: formData.new_profile_emp_address1,
                            
                        },
                        {
                            number: 4,
                            label: 'Address 2',
                            value: formData.new_profile_emp_address2,
                        },
                        {
                            number: 5,
                            label: 'City',
                            value: formData.new_profile_emp_city,
                            
                        },
                        {
                            number: 6,
                            label: 'State',
                            value: formData.new_profile_emp_state_id,
                            
                        },
                        {
                            number: 7,
                            label: 'Postal Code',
                            value: formData.new_profile_emp_zip,
                            
                        },
                        {
                            number: 8,
                            label: 'Country',
                            value: formData.new_profile_emp_country_id,
                            
                        },
                        {
                            number: 9,
                            label: 'Province (if applicable)',
                            value: formData.new_profile_emp_province,
                            
                        },
                    ]
                },
                {
                    name: 'Contact information',
                    fields: [
                        {
                            number: 10,
                            label: 'Telephone Number',
                            value: formData.new_profile_emp_phone,
                            
                        },
                        {
                            number: 11,
                            label: 'Extension',
                            value: formData.new_profile_emp_phone_ext,
                            
                        },
                    ]
                },
                {
                    name: 'Employer identifiers',
                    fields: [
                        {
                            number: 12,
                            label: 'Federal Employer Identification Number (FEIN from IRS)',
                            value: formData.new_profile_emp_fein,
                            
                        },
                        {
                            number: 13,
                            label: 'NAICS Code',
                            value: formData.new_profile_emp_naics,
                            
                        },
                        {
                            number: 14,
                            label: 'Year Commenced Business',
                            value: formData.new_profile_emp_year_commenced,
                            
                        },
                    ]
                }
            ]
        }
        return view;
    }
}

export default employerView